import { render, staticRenderFns } from "./PmtaRelay.vue?vue&type=template&id=1c2b4d59&scoped=true"
import script from "./PmtaRelay.vue?vue&type=script&lang=js"
export * from "./PmtaRelay.vue?vue&type=script&lang=js"
import style0 from "./PmtaRelay.vue?vue&type=style&index=0&id=1c2b4d59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b4d59",
  null
  
)

export default component.exports